export default __webpack_public_path__ + "static/media/History_mobile.fc4a786a.svg";